import { useState } from "react";
import { useStore } from "zustand";
import { isValidPhoneNumber } from "react-phone-number-input";
import { PhoneInput } from "@/components/ui/phone-input";
import { Button } from "@/components/ui/button";
import { useConfigStore, usePageStore } from "@/stores/page";
import { CloseIcon } from "@/components/Icons";
import { SITE_TITLE } from "@/constants";
import api from "@/lib/api/client";
import { useTranslation } from "react-i18next";

const CallForm = ({
  onClose,
  onOk
}: {
  onClose: () => void;
  onOk: () => void;
}) => {
  const { t } = useTranslation("translations");
  const configStore = useConfigStore();
  const appearance = useStore(
    configStore,
    (state) => state.brandKit.appearance_config
  );
  const pageStore = usePageStore();
  const agent = useStore(pageStore, (state) => state.agent);
  const agentMode = useStore(pageStore, (state) => state.agentMode);
  const appearanceConfig = appearance[agentMode];
  const [phoneNumber, setPhoneNumber] = useState("");

  const call = async () => {
    try {
      const res = await api.conversation.v1.call
        .$post({
          json: {
            phone_number: phoneNumber
          }
        })
        .then(
          (res) =>
            res.json() as Promise<{
              success: boolean;
              data: {
                call_id: string;
                created_at: number;
                message: "Call successfully queued.";
                status: "success";
              };
            }>
        );
      console.log("res", res);
      return true;
    } catch (err) {
      return false;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isValidPhoneNumber(phoneNumber)) return;
    call();
    onOk();
  };

  return (
    <form
      className={`mx-auto flex w-full max-w-[352px] flex-1 flex-col gap-4 rounded-md bg-white p-4 shadow-[0px_0px_12.199999809265137px_0px_rgba(0,0,0,0.08)] outline-1 outline-offset-[-1px] outline-slate-200`}
      onSubmit={handleSubmit}
    >
      <div className="flex h-8 items-center gap-2">
        <div className="flex h-full w-8 items-center justify-center rounded-sm">
          <img
            src={appearanceConfig.brand_logo.url || "/images/logo.svg"}
            alt="Astra Logo"
            className="h-full w-full object-contain"
          />
        </div>
        <h4 className="text-xs font-semibold text-black">
          {agent?.name || SITE_TITLE}
        </h4>
        <CloseIcon
          className="ml-auto cursor-pointer text-zinc-600"
          onClick={() => onClose()}
        />
      </div>
      <div className="flex flex-wrap gap-3">
        <div className="inline-flex w-full flex-col gap-1.5">
          <span className="capitalize">{t("agent.form.phoneNumber")}</span>
          <PhoneInput
            value={phoneNumber}
            onChange={(value) => setPhoneNumber(value)}
            international
            defaultCountry="US"
          />
          <span className="text-xs text-red-500">
            {phoneNumber
              ? isValidPhoneNumber(phoneNumber)
                ? undefined
                : t("agent.form.invalidPhone")
              : undefined}
          </span>
        </div>
      </div>

      <Button
        className="bg-primary w-full rounded-md py-2 text-sm font-semibold text-white"
        type="submit"
      >
        Get a Call
      </Button>
    </form>
  );
};

export default CallForm;
